import { useState } from 'react';

import { productItemAddedType } from '../utils';
import { AddedProductItemSectionProps } from '../utils/types';

export const useAddedProductItem = ({ itemData }: AddedProductItemSectionProps) => {
  const [sectionIsOpened, setSectionIsOpened] = useState(false);

  const toggleSection = () => setSectionIsOpened((state) => !state);

  const getProductItemAddedTypeSection = () => {
    return productItemAddedType[itemData.type || 'fixedIncome'];
  };

  const productItemAddTypeData = getProductItemAddedTypeSection();

  return {
    productItemAddTypeData,
    sectionIsOpened,
    toggleSection,
  };
};
